import { Button } from '@/components/ui/button'
import { useTranslation } from 'react-i18next'
import { useAuth } from 'app/frontend/base/config/context/auth'
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import { usePageInfo } from 'app/frontend/base/config/queries'
import LinkButton from '@/components/ui/link-button'

type TeamActionReference = Pick<wowaudit.TeamReference, 'id' | 'path'>

const TeamApplyViewButtons = ({
  team,
  hideView = false,
}: {
  team: TeamActionReference
  hideView?: boolean
}) => {
  const { t } = useTranslation()
  const { accessLevel } = useAuth()
  const {
    data: { user },
  } = usePageInfo()

  const hasCharacterInTeam =
    user?.teamReferences.some(
      (teamReference) => teamReference.id === team.id,
    ) ?? false
  const showApplyButton = !hasCharacterInTeam

  const viewButton = (
    <Button
      variant='outline'
      size='sm'
      className={
        accessLevel === 'none'
          ? 'cursor-not-allowed opacity-50 hover:bg-unset'
          : ''
      }
    >
      {t('shared.view')}
    </Button>
  )

  return (
    <>
      {showApplyButton ? (
        <LinkButton to={`${team.path}/apply`} size='sm' variant='outline'>
          Apply
        </LinkButton>
      ) : null}
      {hideView ? null : (
        <>
          {accessLevel === 'none' ? (
            <Tooltip>
              <TooltipTrigger className='cursor-not-allowed' asChild>
                {viewButton}
              </TooltipTrigger>
              <TooltipContent side='left'>
                {t('dashboard.guild.no-team-access')}
              </TooltipContent>
            </Tooltip>
          ) : (
            <LinkButton to={team.path} size='sm' variant='outline'>
              {t('shared.view')}
            </LinkButton>
          )}
        </>
      )}
    </>
  )
}

export default TeamApplyViewButtons
